
import { appAssetsConfig } from "../../../constants/config/appAssetsConfig";
import "./Loader.scss";

const Loader = () => {
  return (
    <div className="loading-container">
      <div className="loader-wrapper">
        <div className="Loader">
          <img src={appAssetsConfig.DEFAULT_COMPANY_LOGO} alt="ReynaCare" className="loader-image"/>
        </div>
        <div className="bouncing-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
